module.exports = __webpack_public_path__ + "static/media/google_icon.d677415d.svg";